module.exports = {
	"id": "PN",
	"name": "Pitcairn Islands",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": null,
			"39": null,
			"40": null,
			"41": null,
			"42": null,
			"43": null,
			"44": null,
			"45": null,
			"46": null,
			"47": null,
			"48": null,
			"49": null,
			"50": null,
			"51": null,
			"52": 15.294045,
			"53": 24.117899,
			"54": 12.349584,
			"55": null,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 5.879393,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": null,
			"39": 0.590798,
			"40": 0.590798,
			"41": null,
			"42": null,
			"43": null,
			"44": null,
			"45": null,
			"46": null,
			"47": null,
			"48": 11.768315,
			"49": 17.647708,
			"50": null,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": null
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": null,
			"39": null,
			"40": null,
			"41": null,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"3.1": null,
			"3.2": null,
			"5.1": null,
			"6.1": null,
			"7.1": null,
			"9.1": 3.52573
		},
		"ios_saf": {
			"8": 0,
			"10": 2.0123386761,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0542301987927,
			"8.1-8.4": 0.10018799438,
			"9.0-9.2": 0.0477961074105,
			"9.3": 0.729197023314
		},
		"android": {
			"3": 0,
			"4": 0,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0,
			"4.1": 0,
			"4.2-4.3": 0,
			"4.4": 0,
			"4.4.3-4.4.4": 0
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.590798,
			"9": null,
			"10": null,
			"11": 1.172067,
			"5.5": null
		},
		"op_mob": {
			"0": 0,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0
		},
		"edge": {
			"12": null,
			"13": null,
			"14": null
		},
		"ie_mob": {
			"10": 0.348274647887,
			"11": 1.41797535211
		},
		"bb": {
			"7": 0,
			"10": null
		},
		"samsung": {
			"0": null
		},
		"and_uc": {
			"0": null
		},
		"op_mini": {
			"0": 0
		},
		"and_chr": {
			"0": 0
		},
		"and_ff": {
			"0": null
		}
	},
	"total": 98.237135
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/PN.json
 ** module id = 625
 ** module chunks = 0
 **/